export enum DiscoverySectionKinds {
  GENRES = 'genres',
  MOODS = 'moods',
  THEMES = 'themes',
}

export interface DiscoveryTileData<Meta = Record<string, string[]>> {
  id: string;
  title: string;
  description?: string;
  meta?: Meta;
  image: string;
}

export type DiscoveryTileFormula = Record<
  string,
  string | number | null | string[]
>;

export interface DiscoverySection {
  id: string;
  title: string;
  description: string;
  meta?: Record<string, string[]>;
  cta?: string;
  kind: DiscoverySectionKinds;
}

export type DiscoveryGenreTileData = DiscoveryTileData<Record<string, string>>;

export interface DiscoveryGenreTilesSection extends DiscoverySection {
  kind: DiscoverySectionKinds.GENRES;
  tiles: DiscoveryGenreTileData[];
}

export type DiscoveryMoodTileData = DiscoveryTileData<{
  moods: string[];
  formulas: DiscoveryTileFormula[];
}>;

export interface DiscoveryMoodsSection extends DiscoverySection {
  kind: DiscoverySectionKinds.MOODS;
  tiles: DiscoveryMoodTileData[];
}

export type DiscoveryThemeTileData = DiscoveryTileData<{
  moods: string[];
  formulas: DiscoveryTileFormula[];
}>;

export interface DiscoveryThemesSection extends DiscoverySection {
  kind: DiscoverySectionKinds.THEMES;
  tiles: DiscoveryThemeTileData[];
}

export type DiscoverySectionData =
  | DiscoveryThemesSection
  | DiscoveryMoodsSection
  | DiscoveryGenreTilesSection;

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface DiscoveryStore {}
